import { Alpine } from '../../../../vendor/livewire/livewire/dist/livewire.esm';

Alpine.magic('mobile', () => {
    function mobile() {
        const screenWidth = screen.width
        return !(screenWidth > 767)
    }

    window.addEventListener('resize', mobile);

    return mobile()
})
